import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 3h5v5","key":"svg-0"}],["path",{"d":"M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93","key":"svg-1"}]]

/**
 * IconArrowBearRight
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYXJyb3ctYmVhci1yaWdodCIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNMTIgM2g1djUiIC8+CiAgPHBhdGggZD0iTTE3IDNsLTcuNTM2IDcuNTM2YTUgNSAwIDAgMCAtMS40NjQgMy41MzR2Ni45MyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/arrow-bear-right
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconArrowBearRight = createReactComponent('outline', 'arrow-bear-right', 'ArrowBearRight', __iconNode);

export default IconArrowBearRight;